let count = 0

export default function (identifier) {
  if (identifier) {
    return new Id(`${identifier}`)
  } else {
    return new Id(`uuid-${++count}`)
  }
}

class Id {
  constructor (id) {
    this.id = id
    this.href = `#${id}`
  }

  toString () {
    return `url(${this.href})`
  }
}
